// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__Ypoi6 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.logo__QDnem {
  width: 72px;
  height: auto;
}

.loader__dyYdK {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate__fSk4E 1s linear infinite
}

.loader__dyYdK {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate__fSk4E 1s linear infinite
}

.loader__dyYdK::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 5px solid #f7a700;
  animation: prixClipFix__IRIyK 2s linear infinite;
}

@keyframes rotate__fSk4E {
  100% {
    transform: rotate(360deg)
  }
}

@keyframes prixClipFix__IRIyK {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)
  }

  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)
  }

  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)
  }

  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%)
  }

  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0)
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SpinnerLoading/spinnerLoading.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,gDAAyC;AAC3C;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n}\n\n.logo {\n  width: 72px;\n  height: auto;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite\n}\n\n.loader::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 5px solid #f7a700;\n  animation: prixClipFix 2s linear infinite;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg)\n  }\n}\n\n@keyframes prixClipFix {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)\n  }\n\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)\n  }\n\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)\n  }\n\n  75% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%)\n  }\n\n  100% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0)\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__Ypoi6`,
	"logo": `logo__QDnem`,
	"loader": `loader__dyYdK`,
	"rotate": `rotate__fSk4E`,
	"prixClipFix": `prixClipFix__IRIyK`
};
module.exports = ___CSS_LOADER_EXPORT___;
